





















































import { Component, Vue } from 'vue-property-decorator';
import Task from '@/models/Task';
import StarRating from 'vue-star-rating';

@Component({
  components: {
    StarRating
  }
})
export default class TaskList extends Vue {
  isOpened;
  selectedTask: Task;

  get tasks(): any {
    return this.$store.state.taks;
  }

  viewTask(task: Task) {
    this.selectedTask = task;
    this.isOpened = true;
  }
}
